import { Box, useTheme } from '@mui/material'

import useIsPartner from '~/features/partners/hooks/useIsPartner'
import { EChatbotTheme } from '~/features/settings/models'
import useIdentifyViewportWidth from '~/features/ui/hooks/useIdentifyViewportWidth'
import EElement from '~/features/ui/models'
import CreateYourFreeLibbyButton from '~/layouts/chatbot/footer/createYourFreeLibbyButton'
import LogoAndFooterText from '~/layouts/chatbot/footer/logoAndFooterText'
import { store } from '~/store'
import rem from '~/utils/ui'

function Footer() {
  const theme = useTheme()
  const isPartner = useIsPartner()
  const { isExtraSmallScreen, isSmallScreen } = useIdentifyViewportWidth()
  const [chatbotLayout] = store((state) => [state.chatbot.layout])

  return (
    <Box
      id={EElement.chatbotFooter}
      sx={{
        display: 'flex',
        justifyContent: isPartner ? 'flex-end' : 'space-between',
        alignItems: { xxxs: isPartner ? 'flex-end' : 'center', md: 'center' },
        flexDirection: { xxxs: 'row', xs: 'row' },
        gap: 2,
        minHeight: { xxxs: rem(52), md: rem(82) },
        backgroundColor:
          chatbotLayout.selection.theme === EChatbotTheme.linkView
            ? chatbotLayout.options[chatbotLayout.selection.theme][
                chatbotLayout.selection[chatbotLayout.selection.theme]
              ].mainBackgroundColor
            : theme.palette.secondary1,
        paddingInline: { xxxs: 1, xs: 2 },
        width: '100%',
        maxWidth: { xxxs: rem(900), md: rem(800) },
        ...(isSmallScreen || isExtraSmallScreen
          ? { position: 'fixed', bottom: 0 }
          : {}),
      }}
    >
      {!isPartner && <CreateYourFreeLibbyButton />}
      <LogoAndFooterText />
    </Box>
  )
}

export default Footer
